import React from "react";
import "../Footer/Banner/Banner.css";
const About = () => {
  return (
    <div
      id="about"
      className="App bg-dark"
      style={{  padding: "30px" }}
    >
      <h1 style={{ color: "#ffa500", padding: "10px" }}>About Me</h1>
      <div className="container">
        <div className="row pb-3">
          <div className="col-sm-12 col-md-9">
            <br />
            <p className="text-white ms-4">
              I am currently studying in the Electrical Department in Tangail
              polytechnic institute. But my focus is to be a full stake web
              developer. Iam finished font-end & learning back-end. I live in
              Bangladesh, thank you.
            </p>
          </div>
          <div className="col-sm-12 col-md-3">
            <br />
            <button  className="ms-5 fs-3 btn btn-primary" id="contuct">
              Hire Me <i className="fas fa-sign-in-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
